module.exports = __webpack_public_path__ + "Players.jpg?6e1b9a5c2460946e4547677d7e5b0e86";


//////////////////
// WEBPACK FOOTER
// ./static/Players.jpg
// module id = 96
// module chunks = 0